// src/pages/Reports/IssuanceReporting/shared/PrintHouseSelect.tsx
// README.md mục 7 — dropdown chọn Nhà in dùng chung cho RPT-003 (nhập từ nhà in) và RPT-013
// (theo nhà in) — 2 nơi duy nhất cần lọc theo PrintHouseId trong module này.

import React, { useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import { toast } from 'react-toastify';

import { getPrintHouses } from 'helpers/fakebackend_helper';
import { getPaginatedPayload } from './formatters';
import { PrintHouse } from './types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

interface PrintHouseSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const PrintHouseSelect: React.FC<PrintHouseSelectProps> = ({ value, onChange, disabled = false }) => {
  const [printHouses, setPrintHouses] = useState<PrintHouse[]>([]);

  useEffect(() => {
    getPrintHouses({ IsActive: true, PageIndex: 1, PageSize: 200 })
      .then((res) => setPrintHouses(getPaginatedPayload(res).items as PrintHouse[]))
      .catch(() => toast.error(st('khong_the_tai_danh_muc_nha_message')));
  }, []);

  return (
    <Input type="select" value={value} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
      <option value="">{st('tat_ca_nha_in_option')}</option>
      {printHouses.map((ph) => (
        <option key={ph.id} value={ph.id}>{ph.code} - {ph.name}</option>
      ))}
    </Input>
  );
};

export default PrintHouseSelect;
